export const headers = () => {
    // console.info("*-*-* headers *-*-*");
    const CurrentSection = document.querySelector(
        "[data-current-section=headers]"
    ); // Identificar la sección

    const Logo = document.querySelector("[name=logo]");

    Logo.addEventListener("input", (e) => {
        // if ("input" != e.target.nodeName.toLowerCase()) return; // usar esto para detener la propagación en el evento click

        const Target = e.target;

        const Img = Target.files[0];

        if (Img) {
            // if (Img.type != "image/jpeg" && Img.type != "image/png") {
            //     showMessageAdmin("La imagen puede ser de tipo jpg o png", "error");
            //     Target.value = "";
            // } else {
            let dataLogo = new FileReader();
            dataLogo.readAsDataURL(Img);

            dataLogo.addEventListener("loadend", () => {
                let imageSrc = dataLogo.result;

                Logo.parentElement.nextElementSibling.firstElementChild.setAttribute(
                    "src",
                    imageSrc
                );
            });
            // }
        }
    });
};
